import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Level from './Level'

const LevelsContainer = styled.div`
  background-color: inherit;
  width: 866px;
  padding: 21px 0;
  border-top: 1px solid #dedfe0;
`

const Levels = props => {
  let filteredLevels = props.levels
  if (props.levelFilters.length > 0) {
    filteredLevels = filteredLevels.filter(l => {
      return props.levelFilters.includes(l.mock_level_id)
    })
  }
  const list = filteredLevels.map(item => (
    <Level
      key={`level-${item.mock_level_id}`}
      level={item}
      color={props.color}
      course={props.course}
      clickHandler={props.clickHandler}
    />
  ))

  return <LevelsContainer>{list}</LevelsContainer>
}

Levels.propTypes = {
  levels: PropTypes.array.isRequired,
  color: PropTypes.string.isRequired,
  course: PropTypes.object.isRequired,
  clickHandler: PropTypes.func.isRequired,
  levelFilters: PropTypes.array.isRequired
}

export default Levels



// WEBPACK FOOTER //
// ./src/components/productionstatus/Levels.js